module.exports = __webpack_public_path__ + "static/media/header-title.4911c0ea.jpg";